import icn_dashboard_switch from "assets/images/icons/icn_dashboard_switch.svg";
import icn_dashboard_switch_off from "assets/images/icons/icn_dashboard_switch_off.svg";
import img_device_gateway_on from "assets/images/icons/img_device_gateway.svg";
import img_device_gateway_off from "assets/images/icons/img_device_gateway_off.svg";
import icn_dashboard_ap from "assets/images/icons/icn_dashboard_ap.svg";
import icn_dashboard_ap_off from "assets/images/icons/icn_dashboard_ap_off.svg"
import icn_dashboard_proxy from "assets/images/icons/img_unity_proxy_on.svg";
import icn_dashboard_proxy_off from "assets/images/icons/img_unity_proxy_off.svg"
import img_device_nvr_on from "assets/images/icons/img_device_nvr.svg";
import img_device_nvr_off from "assets/images/icons/img_device_nvr_off.svg";
import img_device_camera_on from "assets/images/icons/img_device_camera.svg";
import img_device_camera_off from "assets/images/icons/img_device_camera_off.svg";

export const DEVICE_TYPE = {
  switch: "Switch",
  ap: "Access Point",
  proxy: "Unity Proxy",
  router: "Router",
  nvr: "NVR",
  ipcam: "Camera"
};

export const DEVICE_ATTR = {
  types: {
    AP: 'ap',
    SW: 'switch',
    PROXY: 'proxy',
  },
  managedProtocols: {
    NC: 'nc',
    UNITY: 'unity',
    SNMP: 'snmp',
  }
};

export const DEVICE_ICONS = {
    switch: {
        online: icn_dashboard_switch,
        offline: icn_dashboard_switch_off,
    },
    router: {
        online: img_device_gateway_on,
        offline: img_device_gateway_off,
    },
    ap: {
        online: icn_dashboard_ap,
        offline: icn_dashboard_ap_off,
    },
    // Proxy devices use AP icons temporarily
    proxy: {
        online: icn_dashboard_proxy,
        offline: icn_dashboard_proxy_off,
    },
    nvr: {
        online: img_device_nvr_on,
        offline: img_device_nvr_off,
    },
    ipcam: {
      online: img_device_camera_on,
      offline: img_device_camera_off,
    }
};

export const DEVICE_STATUS_TAG = {
  red: ["offline"],
  green: ["online"],
  grey: ["onboarding"],
  redDark: ["critical"],
  orange: ["warning"],
  blue: ["info"],
};

export const STATUS_TAG_LABEL = {
  offline: "Offline",
  online: "Online",
  onboarding: "Onboarding",
  critical: "Critical",
  warning: "Warning",
  info: "Info",
};

export const formLimitation = {
  vlanId: {
    min: 1,
    max: 4094
  }
}

export const passwordRegex = {
  wireless: {
    ssid: /^[a-zA-Z0-9~!\[\];'\\:"@#$&*]{8,64}$/,
  }
}
